const getRedirectUri = (): string => {
    const MP_APP_ID = process.env.REACT_APP_MP_APP_ID;
    const MP_REDIRECT_URI = process.env.REACT_APP_MP_REDIRECT_URI;
    return `https://auth.mercadopago.com.ar/authorization?client_id=${MP_APP_ID}&response_type=code&platform_id=mp&redirect_uri=${MP_REDIRECT_URI}`;
};

export default getRedirectUri;
